import React from "react";
import { Box } from "@mui/material";
import { SalesChatPanel } from "../components/portfolio/SalesChatPanel";

const ProjectsPortfolioPage: React.FC = () => {
  return (
    <Box sx={{ height: "100%", minHeight: 0, display: "flex", flexDirection: "column" }}>
      <SalesChatPanel />
    </Box>
  );
};

export default ProjectsPortfolioPage;
